export default "__VITE_ASSET__D9Oux7xg__"